import { render, staticRenderFns } from "./LocationEdit.vue?vue&type=template&id=36806f81&"
import script from "./LocationEdit.vue?vue&type=script&lang=js&"
export * from "./LocationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports